var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "155px",
    height: "219px",
    viewBox: "0 0 155 219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.0719844,219 C87.1498054,219 99.9156939,215.736589 110.36965,209.209766 C120.823606,202.682944 129.367704,194.147868 136.001946,183.604539 C142.636187,173.06121 147.461089,161.262724 150.476654,148.209078 C153.492218,135.155433 155,122.101788 155,109.048143 C155,95.7936726 153.793774,82.6396149 151.381323,69.5859697 C148.968872,56.5323246 144.646563,44.8342503 138.414397,34.4917469 C132.182231,24.1492435 123.889429,15.8149931 113.535992,9.48899587 C103.182555,3.16299862 89.964332,0 73.881323,0 C62.8242542,0 52.7723735,2.00825309 43.7256809,6.02475928 C34.6789883,10.0412655 26.8887808,15.5137552 20.3550584,22.4422283 C13.8213359,29.3707015 8.79539559,37.5041265 5.27723735,46.8425034 C1.75907912,56.1808803 0,66.2723521 0,77.1169188 C0,85.5515818 1.30674449,93.8858322 3.92023346,102.11967 C6.53372244,110.353508 10.6549935,117.683631 16.2840467,124.110041 C22.3151751,130.737276 29.653048,136.008941 38.2976654,139.925034 C46.9422827,143.841128 55.7879377,145.799175 64.8346304,145.799175 C75.0875486,145.799175 84.1342412,143.991747 91.9747082,140.376891 C99.8151751,136.762036 106.650454,130.737276 112.480545,122.302613 L113.083658,122.905089 C112.681582,128.729023 111.827173,135.356259 110.520428,142.786795 C109.213684,150.217331 107.052529,157.196011 104.036965,163.722834 C101.021401,170.249656 97.0006485,175.772352 91.9747082,180.290922 C86.9487678,184.809491 80.5155642,187.068776 72.6750973,187.068776 C65.2367056,187.068776 59.0045396,184.458047 53.9785992,179.236589 C48.9526589,174.015131 45.7360571,167.889959 44.3287938,160.861073 L3.61867704,160.861073 C4.82490272,170.099037 7.33787289,178.332875 11.1575875,185.562586 C14.9773022,192.792297 19.9027237,198.917469 25.9338521,203.938102 C31.9649805,208.958735 38.9007782,212.724209 46.7412451,215.234525 C54.5817121,217.744842 63.0252918,219 72.0719844,219 Z M73.5863636,114 C68.1045455,114 63.2825758,112.85 59.1204545,110.55 C54.9583333,108.25 51.5575758,105.25 48.9181818,101.55 C46.2787879,97.85 44.2992424,93.65 42.9795455,88.95 C41.6598485,84.25 41,79.4 41,74.4 C41,69.6 41.7106061,64.9 43.1318182,60.3 C44.5530303,55.7 46.6848485,51.6 49.5272727,48 C52.369697,44.4 55.8212121,41.5 59.8818182,39.3 C63.9424242,37.1 68.5106061,36 73.5863636,36 C79.0681818,36 83.9409091,37.1 88.2045455,39.3 C92.4681818,41.5 96.0719697,44.45 99.0159091,48.15 C101.959848,51.85 104.193182,56.05 105.715909,60.75 C107.238636,65.45 108,70.2 108,75 C108,80.2 107.289394,85.15 105.868182,89.85 C104.44697,94.55 102.315152,98.7 99.4727273,102.3 C96.630303,105.9 93.0772727,108.75 88.8136364,110.85 C84.55,112.95 79.4742424,114 73.5863636,114 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mainPage-concepts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.45738555
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alantm-landingame",
    transform: "translate(-120.000000, -4095.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(120.000000, 4095.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: 9,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -179,
    y1: -126,
    x2: 85.0029159,
    y2: 346.352281,
    id: "Line-2-Copy",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -170.997084,
    y1: -126,
    x2: 93.0058319,
    y2: 346.352281,
    id: "Line-2-Copy-2",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -162.994168,
    y1: -126,
    x2: 101.008748,
    y2: 346.352281,
    id: "Line-2-Copy-3",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -154.991252,
    y1: -126,
    x2: 109.011664,
    y2: 346.352281,
    id: "Line-2-Copy-4",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -146.988336,
    y1: -126,
    x2: 117.01458,
    y2: 346.352281,
    id: "Line-2-Copy-5",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.98542,
    y1: -126,
    x2: 125.017496,
    y2: 346.352281,
    id: "Line-2-Copy-6",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -130.982504,
    y1: -126,
    x2: 133.020412,
    y2: 346.352281,
    id: "Line-2-Copy-7",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -122.979588,
    y1: -126,
    x2: 141.023327,
    y2: 346.352281,
    id: "Line-2-Copy-8",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -114.976673,
    y1: -126,
    x2: 149.026243,
    y2: 346.352281,
    id: "Line-2-Copy-9",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -106.973757,
    y1: -126,
    x2: 157.029159,
    y2: 346.352281,
    id: "Line-2-Copy-10",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -98.9708407,
    y1: -126,
    x2: 165.032075,
    y2: 346.352281,
    id: "Line-2-Copy-11",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -90.9679247,
    y1: -126,
    x2: 173.034991,
    y2: 346.352281,
    id: "Line-2-Copy-12",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.9650088,
    y1: -126,
    x2: 181.037907,
    y2: 346.352281,
    id: "Line-2-Copy-13",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9620929,
    y1: -126,
    x2: 189.040823,
    y2: 346.352281,
    id: "Line-2-Copy-14",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -66.9591769,
    y1: -126,
    x2: 197.043739,
    y2: 346.352281,
    id: "Line-2-Copy-15",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -58.956261,
    y1: -126,
    x2: 205.046655,
    y2: 346.352281,
    id: "Line-2-Copy-16",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -50.9533451,
    y1: -126,
    x2: 213.049571,
    y2: 346.352281,
    id: "Line-2-Copy-17",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -42.9504291,
    y1: -126,
    x2: 221.052487,
    y2: 346.352281,
    id: "Line-2-Copy-18",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -34.9475132,
    y1: -126,
    x2: 229.055403,
    y2: 346.352281,
    id: "Line-2-Copy-19",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -26.9445973,
    y1: -126,
    x2: 237.058319,
    y2: 346.352281,
    id: "Line-2-Copy-20",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.9416813,
    y1: -126,
    x2: 245.061235,
    y2: 346.352281,
    id: "Line-2-Copy-21",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.9387654,
    y1: -126,
    x2: 253.064151,
    y2: 346.352281,
    id: "Line-2-Copy-22",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.93584947,
    y1: -126,
    x2: 261.067066,
    y2: 346.352281,
    id: "Line-2-Copy-23",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.06706646,
    y1: -126,
    x2: 269.069982,
    y2: 346.352281,
    id: "Line-2-Copy-24",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.0699824,
    y1: -126,
    x2: 277.072898,
    y2: 346.352281,
    id: "Line-2-Copy-25",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.0728983,
    y1: -126,
    x2: 285.075814,
    y2: 346.352281,
    id: "Line-2-Copy-26",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.0758143,
    y1: -126,
    x2: 293.07873,
    y2: 346.352281,
    id: "Line-2-Copy-27",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.0787302,
    y1: -126,
    x2: 301.081646,
    y2: 346.352281,
    id: "Line-2-Copy-28",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.0816461,
    y1: -126,
    x2: 309.084562,
    y2: 346.352281,
    id: "Line-2-Copy-29",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.0845621,
    y1: -126,
    x2: 317.087478,
    y2: 346.352281,
    id: "Line-2-Copy-30",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.087478,
    y1: -126,
    x2: 325.090394,
    y2: 346.352281,
    id: "Line-2-Copy-31",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.0903939,
    y1: -126,
    x2: 333.09331,
    y2: 346.352281,
    id: "Line-2-Copy-32",
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sports-car",
    transform: "translate(0.000000, 47.000000)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNine);
export default ForwardRef;